import { Grid } from '@focaldata/cin-ui-components'
import React from 'react'
import {
  InfoPanel,
  InfoPanelItem,
  InfoPanelVariant
} from '../../../components/InfoPanel'
import { TextHighlight, TextWeight } from '../../../constants/text'
import { IncompleteLanguage } from '../../Translations/hooks/useTranslationsCompletenessValidation'
import useStyles from './SurveyStats.styles'

interface Props {
  // Allocated, non-master languages that fall below 100% translated.
  // Always non-empty when this panel is rendered — the parent
  // `SurveyErrorPanel` decides whether to mount us based on the same flag.
  incompleteLanguages: ReadonlyArray<IncompleteLanguage>
}

const TranslationsErrorPanel: React.FC<Props> = ({ incompleteLanguages }) => {
  const { classes } = useStyles()

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      className={classes.rightChild}
    >
      <Grid item xs="auto">
        <InfoPanel
          title="INCOMPLETE TRANSLATIONS"
          variant={InfoPanelVariant.Error}
        >
          <InfoPanelItem>
            <Grid container className={classes.feasibilityInfoPanel}>
              <Grid item xs={12} className={classes.paddingBottom}>
                <p style={{ color: TextHighlight.Background }}>
                  Sorry, your survey cannot be launched because one or more
                  languages you allocated on the Audience tab are missing
                  translations. Respondents who pick an incomplete language
                  would see the master text instead of their selection. Fill the
                  missing fields under <em>Translations</em>:
                </p>
              </Grid>
              {incompleteLanguages.map((lang) => (
                <Grid
                  item
                  xs={12}
                  key={lang.code}
                  className={classes.paddingLeft}
                >
                  <p style={{ fontWeight: TextWeight.SemiBold }}>
                    &#x2022; {lang.name}: {lang.translated} / {lang.total}{' '}
                    translated ({lang.pct}%)
                  </p>
                </Grid>
              ))}
              <Grid item xs={12} className={classes.paddingTop}>
                <p style={{ color: TextHighlight.Background }}>
                  If a language isn&apos;t needed, remove its allocation on the
                  Audience tab; otherwise, open <em>Translations</em> from the
                  breadcrumb to finish the missing fields. If this questionnaire
                  is already written in the language respondents will see, clear{' '}
                  <em>Needs translation</em> on the Survey tab instead.
                </p>
              </Grid>
            </Grid>
          </InfoPanelItem>
        </InfoPanel>
      </Grid>
    </Grid>
  )
}

export default TranslationsErrorPanel
